"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { cj, KEY_CODES } from "../utils";
import { SliderContext } from "./shared/sliderContext";
const SliderDot = /*#__PURE__*/ React.forwardRef(function SliderDot({ index, focusedDot, handleFocus, setFocusedDot }, ref) {
    const { slideAmount, navSpacing, navNumbers, slide: { current: selectedSlide }, setCurrentSlide } = React.useContext(SliderContext);
    const innerRef = React.useRef(null);
    React.useImperativeHandle(ref, ()=>innerRef.current);
    React.useEffect(()=>{
        if (focusedDot === index) {
            var _innerRef_current;
            (_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.focus();
        }
    }, [
        focusedDot,
        index
    ]);
    const isSlideActive = selectedSlide === index;
    const label = navNumbers ? index + 1 : "";
    return /*#__PURE__*/ React.createElement("div", {
        className: `w-slider-dot ${isSlideActive ? "w-active" : ""}`,
        "aria-label": `Show slide ${index + 1} of ${slideAmount}`,
        "aria-pressed": isSlideActive,
        role: "button",
        tabIndex: isSlideActive ? 0 : -1,
        style: {
            marginRight: `${navSpacing}px`,
            marginLeft: `${navSpacing}px`
        },
        onClick: (e)=>{
            e.stopPropagation();
            setFocusedDot(index);
            setCurrentSlide(index);
        },
        ref: innerRef,
        onKeyDown: handleFocus
    }, label);
});
const SliderNav = /*#__PURE__*/ React.forwardRef(function SliderNav(_param, ref) {
    var { className = "" } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    const { slideAmount, navInvert, navNumbers, navRound, navShadow, setAutoplayPause, setCurrentSlide } = React.useContext(SliderContext);
    const [focusedDot, setFocusedDot] = React.useState(null);
    const handleFocus = (e)=>{
        switch(e.key){
            case KEY_CODES.ENTER:
            case KEY_CODES.SPACE:
                e.preventDefault();
                if (focusedDot !== null) {
                    setCurrentSlide(focusedDot);
                }
                break;
            case KEY_CODES.ARROW_LEFT:
            case KEY_CODES.ARROW_UP:
                e.preventDefault();
                setFocusedDot((prev)=>Math.max((prev !== null && prev !== void 0 ? prev : 0) - 1, 0));
                break;
            case KEY_CODES.ARROW_RIGHT:
            case KEY_CODES.ARROW_DOWN:
                e.preventDefault();
                setFocusedDot((prev)=>Math.min((prev !== null && prev !== void 0 ? prev : 0) + 1, slideAmount - 1));
                break;
            case KEY_CODES.HOME:
                e.preventDefault();
                setFocusedDot(0);
                break;
            case KEY_CODES.END:
                e.preventDefault();
                setFocusedDot(slideAmount - 1);
                break;
            default:
                return;
        }
    };
    const dots = [
        ...Array(slideAmount).keys()
    ].map((_, i)=>/*#__PURE__*/ React.createElement(SliderDot, {
            key: i,
            index: i,
            focusedDot: focusedDot,
            handleFocus: handleFocus,
            setFocusedDot: setFocusedDot
        }));
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, props), {
        onFocus: (e)=>{
            e.stopPropagation();
            setAutoplayPause(true);
        },
        onBlur: ()=>setAutoplayPause(false),
        onMouseLeave: (e)=>e.stopPropagation(),
        className: cj(className, `w-slider-nav ${navInvert ? "w-slider-nav-invert" : ""} ${navShadow ? "w-shadow" : ""} ${navRound ? "w-round" : ""} ${navNumbers ? "w-num" : ""}`),
        ref: ref
    }), dots);
});
export default SliderNav;
